export const SAVE = 'ADAndDBenefitsTugo.SAVE';
export const VALUE_CHANGED = 'ADAndDBenefitsTugo.VALUE_CHANGED';
export const LOAD = 'ADAndDBenefitsTugo.VALUE_LOAD';
export const NEXT = 'ADAndDBenefitsTugo.NEXT';
export const RESET = 'ADAndDBenefitsTugo.RESET';
export const RESET_FORM_STATE = 'ADAndDBenefitsTugo.RESET_FORM_STATE';



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.ADAndDBenefits/constants.js